// Code generated by scripts/i18nstringsgen from i18nstrings/ru/*.toml. DO NOT EDIT.

import { plural } from "./i18nstrings_plural_gen.js";
import type { Strings } from "./i18nstrings_types_gen.js";

export const RU: Strings = {
  admin: {
    admins: {
      empty: () => "Укажите ник в телеграме.",
      hint: () => "Члены оргкомитета входят через телеграм. Добавьте их ник без @.",
      notYourself: () => "Себя из оргкомитета убрать нельзя.",
      placeholder: () => "Ник в телеграме",
      title: () => "Оргкомитет",
    },
    contest: {
      final: () => "Финал и итоги",
      questions: () => "Вопросы",
      settings: () => "Настройки",
      settingsHint: () => "Даты — календарные дни по Москве, этап идёт с первого дня по последний включительно. Формат: ГГГГ-ММ-ДД.",
      stage1: () => "Первый этап и шорт-лист",
    },
    contests: {
      create: (year: string) => `Создать конкурс ${year} года`,
      row: (year: string) => `Вопрос года — ${year}`,
      title: () => "Конкурсы",
    },
    createUsers: {
      title: () => "Создать пользователей",
    },
    dates: {
      factcheckEnd: () => "Фактчек: последний день",
      factcheckStart: () => "Фактчек: первый день",
      finalEnd: () => "Финал: последний день",
      finalStart: () => "Финал: первый день",
      invalid: (field: string) => `Поле «${field}» должно быть датой вида ГГГГ-ММ-ДД.`,
      nominationEnd: () => "Номинация: последний день",
      nominationStart: () => "Номинация: первый день",
      placeholder: () => "ГГГГ-ММ-ДД",
      prelimEnd: () => "Первый этап: последний день",
      prelimStart: () => "Первый этап: первый день",
      questionsFrom: () => "Отыгрыш турнира начался не раньше",
      questionsTo: () => "Отыгрыш турнира начался не позже",
      results: () => "Подведение итогов",
    },
    fields: {
      answer: () => "Ответ",
      author: () => "Авторы",
      comment: () => "Комментарий",
      nezachet: () => "Незачёт",
      source: () => "Источники",
      text: () => "Вопрос",
      zachet: () => "Зачёт",
    },
    final: {
      ballots: (complete: string, experts: number) => `Полных бюллетеней экспертного жюри: ${complete} из ${experts} ${plural("ru", experts, "члена жюри", "членов жюри", "членов жюри")}.`,
      juryPlace: () => "Место у жюри",
      points: () => "Сумма оценок",
      popularPlace: () => "Место у зрителей",
      popularPoints: () => "Баллы у зрителей",
      publish: () => "Опубликовать итоги",
      publishConfirm: () => "Опубликовать итоги? Их сразу увидят все.",
      publishHint: (year: string) => `Опубликованные итоги видны всем на странице /${year}/results/, с авторами и местами.`,
      publishTitle: () => "Итоги",
      published: (date: string) => `Итоги опубликованы ${date}.`,
      rankSum: () => "Сумма рангов",
      unpublish: () => "Скрыть итоги",
      voters: (n: number) => `Зрители отдали ${n} ${plural("ru", n, "голос", "голоса", "голосов")}.`,
    },
    jury: {
      expert: () => "Экспертное",
      hint: () => "Члены жюри входят через телеграм под тем ником, который здесь указан.",
      incomplete: () => "Укажите имя, ник в телеграме и жюри.",
      kind: () => "Жюри",
      name: () => "Имя и фамилия",
      people: () => "Народное",
      telegram: () => "Телеграм",
      title: () => "Жюри",
    },
    numbering: {
      afterNomination: (date: string) => `Номера раздаются после конца номинации, ${date}.`,
      alreadyDone: () => "Номера уже розданы.",
      confirm: () => "Номера раздаются один раз и в случайном порядке. Раздать?",
      deal: () => "Раздать номера",
      done: (n: number) => `Номера получили ${n} ${plural("ru", n, "вопрос", "вопроса", "вопросов")}.`,
      pending: (n: number) => `С учётом запасных и повторов в конкурсе ${n} ${plural("ru", n, "вопрос", "вопроса", "вопросов")}.`,
      title: () => "QY-номера",
    },
    numbers: {
      expertCutoff: () => "Шорт-лист экспертного жюри, не меньше",
      invalid: (field: string) => `Поле «${field}» должно быть целым числом больше нуля.`,
      mainSlots: () => "Вопросов на номинатора",
      peopleCutoff: () => "Шорт-лист народного жюри, не меньше",
      portionDays: () => "Дней на порцию",
      portionSize: () => "Вопросов в порции",
      reserveSlots: () => "Запасных вопросов на номинатора",
    },
    page: {
      title: () => "Оргкомитет",
    },
    question: {
      aiFailed: (error: string) => `Модель не ответила: ${error}`,
      approveEmpty: () => "Нельзя одобрить вопрос без текста.",
      approved: () => "Одобрен",
      authorDeclined: () => "Автор против участия в шорт-листе",
      datesOff: () => "Даты не подходят",
      datesOk: () => "Даты подходят",
      datesUnknown: () => "Даты неизвестны",
      duplicates: () => "Возможные повторы",
      duplicatesHint: () => "У этих вопросов тот же ответ. Если это один и тот же вопрос, объедините их: номинации перейдут к выбранному вопросу.",
      edit: () => "Правка",
      editHint: () => "Здесь правится обезличенный текст, который видит жюри. Авторов жюри не видит, они появятся только в итогах.",
      extra: () => "Дополнительный контекст (Markdown)",
      factcheck: () => "Фактчек (Markdown)",
      link: () => "Ссылка на вопрос",
      mergeConfirm: () => "Объединить? Этот вопрос будет отклонён, а его номинации перейдут к выбранному.",
      mergeInto: (name: string) => `Объединить с ${name}`,
      mergeRefused: () => "С этим вопросом объединить нельзя.",
      merged: () => "Объединён с другим",
      missing: () => "Такого вопроса нет.",
      new: () => "Не проверен",
      noText: () => "Нет текста",
      nominatedBy: (who: string, rating: string, slot: string) => `Номинировал(а) ${who}, ID на рейтинге ${rating}, ${slot}.`,
      openLink: () => "Открыть ссылку",
      openTournament: () => "Открыть турнир",
      parse: () => "Распознать",
      parseFailed: () => "Не нашли в тексте ответ. Проверьте, что в нём есть строка «Ответ:».",
      pasteHint: () => "Мы не смогли разобрать вопрос. Вставьте его полный текст с ответом, комментарием и авторами.",
      pasteTitle: () => "Текст вопроса",
      pin: () => "Шорт-лист",
      pinAdd: () => "Добавить вручную",
      pinNone: () => "По голосам",
      pinRemove: () => "Убрать вручную",
      preview: () => "Как его увидит жюри",
      published: () => "Вопрос опубликован (его видит народное жюри)",
      rejected: () => "Отклонён",
      sourceText: () => "Что прислал номинатор",
      status: () => "Статус",
      statusLine: (status: string, dates: string) => `${status}. ${dates}.`,
      tournament: () => "Турнир",
      tournamentId: () => "ID турнира на рейтинге",
      tournamentStart: () => "Начало отыгрыша",
      unnumbered: (id: string) => `Без номера (№ ${id})`,
    },
    questions: {
      answer: () => "Ответ",
      count: (n: number) => `Всего ${n} ${plural("ru", n, "вопрос", "вопроса", "вопросов")}.`,
      dates: () => "Даты",
      number: () => "Номер",
      status: () => "Статус",
      suggestions: () => "Правки",
    },
    site: {
      files: () => "Файлы",
      pages: () => "Страницы",
      title: () => "Сайт",
    },
    stage1: {
      byExpert: () => "По экспертному жюри",
      byPeople: () => "По народному жюри",
      byPin: () => "Вручную",
      expert: () => "Экспертное",
      freeze: () => "Утвердить",
      freezeConfirm: () => "Утвердить шорт-лист? После этого отметки жюри на него не влияют.",
      freezeHint: (n: number) => `Сейчас в шорт-листе ${n} ${plural("ru", n, "вопрос", "вопроса", "вопросов")}. Утверждённый шорт-лист открывает финальное голосование и больше не меняется от отметок.`,
      freezeTitle: () => "Утвердить шорт-лист",
      frozen: (date: string) => `Шорт-лист утверждён ${date}.`,
      lead: (expert: number, people: number) => `В шорт-лист попадают не меньше ${expert} ${plural("ru", expert, "вопроса", "вопросов", "вопросов")} по отметкам экспертного жюри и не меньше ${people} ${plural("ru", people, "вопроса", "вопросов", "вопросов")} по отметкам народного, вместе с вопросами, у которых столько же отметок, сколько у последнего прошедшего.`,
      people: () => "Народное",
      shortlist: () => "Шорт-лист",
      unfreeze: () => "Вернуть к подсчёту по отметкам",
      unfreezeConfirm: () => "Шорт-лист снова будет считаться по отметкам. Вернуть?",
      unfreezePublished: () => "Итоги уже опубликованы, шорт-лист менять нельзя.",
    },
    suggestions: {
      accept: () => "Принять",
      accepted: () => "Принята",
      authorName: () => "имя автора",
      byAi: () => "Модель",
      byRule: () => "Правило",
      change: (field: string, quote: string, replacement: string) => `${field}: «${quote}» → ${replacement}`,
      delete: () => "удалить",
      link: () => "ссылка на турнир или вопрос",
      none: () => "Правок нет.",
      reject: () => "Отклонить",
      rejected: () => "Отклонена",
      rerun: () => "Проверить моделью ещё раз",
      stale: () => "Этого фрагмента в тексте уже нет. Поправьте текст вручную.",
      title: () => "Предложенные правки",
      why: (source: string, reason: string) => `${source}: ${reason}`,
    },
  },
  anon: {
    placeholder: () => "[автор вопроса]",
  },
  auth: {
    login: {
      fieldsRequired: () => "Введите логин и пароль.",
      invalid: () => "Неверный логин или пароль.",
    },
    page: {
      title: () => "Вход — Вопрос года",
    },
    tg: {
      codeMissing: () => "Этот код никто не ждёт. Начните вход заново.",
      notConfigured: () => "Вход через телеграм на этом сайте не настроен.",
      telegramTaken: () => "Этот телеграм уже привязан к другому пользователю.",
    },
    username: {
      format: () => "Логин — от 3 до 64 латинских букв, цифр и знаков . _ -",
      reserved: () => "Этот логин занят.",
    },
  },
  banner: {
    before: (date: string) => `Номинация вопросов откроется ${date}.`,
    nomination: (date: string) => `Номинировать вопросы можно до ${date} включительно.`,
  },
  bot: {
    login: {
      hint: (url: string) => `Откройте ${url} и нажмите «Войти через телеграм». Страница покажет код, который нужно прислать мне.`,
    },
    register: {
      done: () => "Готово. Вернитесь на страницу, с которой начали: вы вошли.",
      expired: () => "Код истёк. Откройте страницу входа ещё раз, там будет новый.",
    },
    texts: {
      down: () => "Сайт сейчас не отвечает. Попробуйте через минуту.",
      help: () => "Пришлите мне код со страницы входа, и я вас впущу.",
    },
  },
  cms: {
    badFileName: () => "Недопустимое имя файла.",
    badPath: () => "Адрес состоит из латинских строчных букв, цифр, точек, дефисов, подчёркиваний и косых черт и не начинается с адреса раздела сайта.",
    body: () => "Текст",
    byShell: () => "импорт",
    bytes: (n: string) => `${n} Б`,
    conflict: () => "Страницу уже изменили, пока вы её правили. Скопируйте свой текст, откройте редактор заново и внесите правки ещё раз.",
    delete: () => "Удалить страницу",
    deleteConfirm: () => "Удалить страницу? Её можно будет восстановить из истории.",
    deleteFileConfirm: () => "Удалить файл?",
    deleted: () => ", удалена",
    editThis: () => "Править эту страницу",
    file: () => "Файл",
    filesHint: () => "Файл доступен по адресу /папка/имя. Картинку можно вставить в страницу так: ![подпись](/img/картинка.jpg).",
    folder: () => "Папка",
    format: () => "Формат",
    history: () => "История",
    historyHint: () => "Выберите версию, чтобы увидеть, что в ней изменилось.",
    html: () => "HTML",
    markdown: () => "Markdown",
    movedTo: (path: string) => `Перенесена на ${path}`,
    newPage: () => "Новая страница",
    noTitle: () => "Укажите заголовок.",
    notFound: () => "Такой страницы нет.",
    notYet: () => "Эта страница появится позже.",
    open: () => "Открыть на сайте",
    pages: () => "Страницы",
    path: () => "Адрес",
    pathPlaceholder: () => "2026/rules",
    preview: () => "Предпросмотр",
    restore: () => "Открыть эту версию в редакторе",
    restored: () => "Это текст из истории. Он ещё не сохранён.",
    revision: (when: string, by: string) => `${when}, ${by}`,
    size: () => "Размер",
    taken: () => "Страница с таким адресом уже есть.",
    title: () => "Заголовок",
    type: () => "Тип",
    upload: () => "Загрузить",
    uploadFailed: () => "Файл не выбран или больше 20 МБ.",
    varsHint: (examples: string) => `На страницах года можно писать переменные регламента, например ${examples}.`,
  },
  common: {
    add: () => "Добавить",
    errorTitle: () => "Не получилось",
    home: () => "Главная",
    ratingId: () => "Ваш ID на рейтинге (rating.chgk.info)",
    ratingIdInvalid: () => "ID на рейтинге — это число со страницы игрока на rating.chgk.info.",
    remove: () => "Удалить",
    save: () => "Сохранить",
    saved: () => "Сохранено.",
    siteName: () => "Вопрос года",
    titleSuffix: (page: string, site: string) => `${page} — ${site}`,
    toHome: () => "На главную",
  },
  contest: {
    juryPending: () => "<состав жюри будет вписан позже>",
    name: (year: string) => `Вопрос года — ${year}`,
    none: () => "Конкурс ещё не объявлен.",
    stage: {
      before: () => "Конкурс скоро начнётся.",
      counting: () => "Голосование закончилось, мы подводим итоги.",
      done: () => "Итоги подведены.",
      factcheck: () => "Идёт фактчек шорт-листа.",
      final: () => "Идёт финальное голосование.",
      nomination: () => "Идёт номинация вопросов.",
      prelim: () => "Идёт первый этап голосования жюри.",
      review: () => "Номинация закончилась, оргкомитет готовит вопросы.",
    },
  },
  dates: {
    and: () => " и ",
    fromTo: (from: string, to: string) => `с ${from} по ${to}`,
    months: {
      april: () => "апреля",
      august: () => "августа",
      december: () => "декабря",
      february: () => "февраля",
      january: () => "января",
      july: () => "июля",
      june: () => "июня",
      march: () => "марта",
      may: () => "мая",
      november: () => "ноября",
      october: () => "октября",
      september: () => "сентября",
    },
  },
  final: {
    closed: (from: string, to: string) => `Финальное голосование идёт с ${from} по ${to}.`,
    jury: {
      lead: (date: string) => `Оцените каждый вопрос по десятибалльной шкале до ${date} включительно. Оценки сохраняются сразу. Бюллетень засчитывается, только когда оценены все вопросы.`,
      notExpert: () => "Эта страница для экспертного жюри.",
      progress: (marked: string, total: number) => `Оценено ${marked} из ${total} ${plural("ru", total, "вопроса", "вопросов", "вопросов")}.`,
      scale: () => "Оценка от 1 до 10",
      title: () => "Оценки жюри",
    },
    noShortlist: () => "Шорт-лист ещё не опубликован.",
    popular: {
      choose: () => "Выберите вопрос",
      counted: () => "Ваш голос учтён. Его можно изменить.",
      first: () => "Лучший вопрос (5 баллов)",
      invalid: () => "Выберите три разных вопроса из шорт-листа.",
      lead: (date: string) => `Выберите три лучших вопроса шорт-листа до ${date} включительно. Первый получит 5 баллов, второй 4, третий 3. Голос можно изменить до конца голосования.`,
      second: () => "Второй (4 балла)",
      submit: () => "Проголосовать",
      third: () => "Третий (3 балла)",
      title: () => "Зрительское голосование",
    },
  },
  forms: {
    failed: () => "Не сохранилось. Нажмите «Сохранить».",
    hideAnswers: () => "Скрыть все ответы",
    saving: () => "Сохраняю…",
    showAnswers: () => "Показать все ответы",
  },
  nominate: {
    error: {
      badLink: () => "Ссылка на опубликованный вопрос должна начинаться с https://.",
      badTournament: () => "Ссылка на турнир должна начинаться с https://.",
      fileTooBig: () => "Файл больше 20 МБ.",
      missing: (fields: string) => `Заполните обязательные поля: ${fields}.`,
      noLink: () => "Укажите ссылку на опубликованный вопрос.",
      noTournament: () => "Укажите ссылку на турнир.",
    },
    field: {
      answer: () => "Ответ",
      author: () => "Автор",
      comment: () => "Комментарий",
      handout: () => "Раздаточный материал",
      handoutHint: () => "Текст раздатки. Если раздатка — картинка или другой файл, прикрепите его ниже.",
      nezachet: () => "Незачёт",
      source: () => "Источник",
      text: () => "Текст вопроса",
      zachet: () => "Зачёт",
    },
    page: {
      adminPreview: () => "Номинация ещё не открыта. Вы видите форму, потому что вы админ. Сохранённые сейчас вопросы попадут в конкурс, поэтому после проверки очистите их.",
      closed: (from: string, to: string) => `Номинация вопросов идёт с ${from} по ${to}.`,
      eligible: (from: string, to: string) => `Подходят вопросы турниров, отыгрыш которых начался с ${from} по ${to}.`,
      filesLost: () => "Прикреплённые файлы не сохранились, их нужно выбрать заново.",
      howTo: () => "Если вопрос опубликован в базе gotquestions, достаточно ссылки на него. Если вопрос опубликован в другом месте или не опубликован, вставьте вопрос целиком и нажмите «Распарсить». Потом проверьте поля: текст вопроса, ответ, источник и автор обязательны. Для неопубликованного вопроса нужна ещё ссылка на турнир.",
      lead: (main: string, reserves: string, until: string) => `Можно номинировать до ${main} вопросов и ${reserves} запасных. Форму можно менять до ${until} включительно.`,
      notSaved: () => "Номинация не сохранена. Исправьте отмеченные вопросы и сохраните ещё раз.",
      reserves: () => "Запасные вопросы",
      submit: () => "Сохранить номинацию",
      title: () => "Номинация вопросов",
    },
    slot: {
      dropFile: () => "Убрать прикреплённый файл",
      file: () => "Файл для раздатки",
      fileHint: () => "Картинка или другой файл, до 20 МБ. Новый файл заменит прикреплённый.",
      link: () => "Ссылка на опубликованный вопрос",
      linkHint: () => "Ссылка на вопрос в базе gotquestions или на пост, где вопрос опубликован. Вопрос из базы или из телеграм-канала можно загрузить кнопкой «Загрузить».",
      linkOnly: () => "Сохранили ссылку. Текст вопроса оргкомитет заберёт из базы сам.",
      load: () => "Загрузить",
      loadFailed: () => "Не получилось загрузить вопрос по этой ссылке. Вставьте его текст во вкладке «Текст».",
      main: (n: string) => `Вопрос ${n}`,
      parse: () => "Распарсить",
      parseFailed: () => "Не нашли в тексте ответ. Проверьте, что в нём есть строка «Ответ:», или заполните поля сами.",
      parsed: (answer: string) => `Распознали вопрос с ответом «${answer}».`,
      paste: () => "Вопрос целиком",
      pasteHint: () => "Вставьте вопрос с ответом, источником и автором. «Распарсить» разложит его по полям.",
      published: () => "Вопрос опубликован",
      reserve: (n: string) => `Запасной вопрос ${n}`,
      tabFields: () => "Поля",
      tabText: () => "Текст",
      tournament: () => "Ссылка на турнир",
      unpublished: () => "Вопрос не опубликован",
    },
  },
  profile: {
    loggedInAs: (who: string) => `Вы вошли как ${who}.`,
    logout: () => "Выйти",
    ratingHint: () => "Мы спрашиваем ID при номинации и при зрительском голосовании, чтобы один человек голосовал один раз.",
    title: () => "Профиль",
  },
  question: {
    answer: () => "Ответ:",
    author: () => "Автор(ы):",
    comment: () => "Комментарий:",
    factcheck: () => "Фактчек",
    label: (number: string) => `Вопрос ${number}.`,
    nezachet: () => "Незачёт:",
    showAnswer: () => "Показать ответ",
    source: () => "Источник(и):",
    tournament: () => "Турнир:",
    unnumbered: () => "Вопрос.",
    zachet: () => "Зачёт:",
  },
  results: {
    places: (jury: string, popular: string, rank_sum: string, points: string) => `Место у жюри: ${jury}, место у зрителей: ${popular}, сумма рангов у жюри: ${rank_sum}, баллы у зрителей: ${points}`,
    shortlist: () => "Шорт-лист",
    title: () => "Результаты",
  },
  server: {
    error: {
      badRequest: () => "Запрос не удалось разобрать.",
      internal: () => "Что-то сломалось на нашей стороне. Попробуйте ещё раз.",
    },
  },
  vote: {
    factcheck: {
      lead: (date: string) => `Это вопросы предварительного шорт-листа, которые вы отметили, вместе с фактчеком. Если после фактчека вопрос вам больше не нравится, снимите отметку до ${date} включительно.`,
      nothing: () => "Вы не отмечали вопросов, которые попали в предварительный шорт-лист.",
    },
    like: () => "Нравится",
    page: {
      closed: (from: string, to: string) => `Первый этап и фактчек идут с ${from} по ${to}.`,
      notJuror: () => "Эта страница для членов жюри. Если вы в жюри, проверьте, что вошли через тот телеграм, который сообщили оргкомитету.",
      nothingYet: () => "Вопросы ещё не опубликованы.",
      title: () => "Голосование жюри",
    },
    portion: {
      empty: () => "В этой порции для вас вопросов нет.",
      lead: (days: number) => `Вопросы выходят порциями, новая открывается раз в ${days} ${plural("ru", days, "день", "дня", "дней")}. Отмечайте понравившиеся вопросы, отметки сохраняются сразу. Отметки в прошлых порциях можно менять до конца этапа.`,
      next: (date: string) => `Следующая порция откроется ${date}.`,
      notOpen: () => "Эта порция ещё не открыта.",
      tabs: () => "Порции",
      title: (n: string, date: string) => `Порция ${n}, открыта ${date}.`,
    },
  },
};

export default RU;
